import { Edit, SelectInput, SimpleForm, TextInput } from "react-admin";

export const PartnerEarningEdit = () => (
	<Edit>
		<SimpleForm>
			<TextInput source="id" disabled />
			<SelectInput
				source="status"
				choices={[
					{ id: "accrued", name: "Accrued" },
					{ id: "processing", name: "Processing" },
					{ id: "unpayable", name: "Unpayable" },
					{ id: "void", name: "Void" },
					{ id: "paid", name: "Paid" },
				]}
			/>
			<TextInput source="payoutId" label="Payout ID" />
		</SimpleForm>
	</Edit>
);
